/**
 * Gets initial font size for an element
 *
 * @param {HTMLElement} element
 * @return {number} font size of an element
 */
function getInitialFontSize(element: HTMLElement): number {
    if (element.dataset['textResizeInitial']) {
        return parseInt(element.dataset['textResizeInitial']);
    } else {
        const fontSize = window.getComputedStyle(element).getPropertyValue('font-size').replace('px', '');
        element.dataset['textResizeInitial'] = fontSize;
        return parseInt(fontSize);
    }
}

/**
 * Resize text in element to fit it's height
 *
 * @param {HTMLElement} element
 */
export function resizeText(element: HTMLElement): void {
    const initialFontSize = getInitialFontSize(element);
    element.style.fontSize = initialFontSize + 'px';
    element.style.opacity = '0';

    const size = findTextSize(element, initialFontSize, 1);
    findTextSize(element, size, 0.1);

    element.style.opacity = '1';
}

function findTextSize(element: HTMLElement, currentFontSize: number, modifier: number): number {
    while (element.scrollHeight > element.offsetHeight) {
        currentFontSize -= modifier;
        element.style.fontSize = currentFontSize + 'px';
    }
    while (element.scrollHeight <= element.offsetHeight) {
        currentFontSize += modifier;
        element.style.fontSize = currentFontSize + 'px';
    }

    currentFontSize -= modifier;
    element.style.fontSize = currentFontSize + 'px';

    return currentFontSize;
}
